import { useOptionalAviosAuth } from './useAviosAuth';

export function useHasAviosAuthProvider(): boolean {
  const authState = useOptionalAviosAuth();
  return authState !== undefined;
}
